export default __webpack_public_path__ + "static/media/previous-page.7065779d.svg";